/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TCreateMessageForAddformModel = IModel<ICreateMessageForAddformRequest, TCreateMessageForAddformResponse>;

export interface ICreateMessageForAddformRequest {
  /** Адрес объект или как минимум регион. Ожидается что сюда приходит строка из саджеста **/
  address: string;
  /** Тип объявления **/
  category: ECategory;
  /** Комментарий **/
  comment?: string | null;
  /** Код подтверждения телефона **/
  confirmationCode?: string | null;
  /** Валюта **/
  currency?: ECurrency | null;
  /** Тип сделки **/
  dealType: EDealType;
  /** Почта **/
  email: string;
  /** Телефон **/
  phone: string;
  /** Цена **/
  price?: number | null;
  /** Кол-во комнат **/
  roomCount?: ERoomCount | null;
  /** Источник заявки **/
  source?: string | null;
}

export type TCreateMessageForAddformResponse =
  | ICreateMessageForAddformResponse200
  | ICreateMessageForAddformResponse400;

export interface ICreateMessageForAddformResponse200 extends IModelResponse<ICreateMessageForAddformResponse> {
  statusCode: 200;
}

export interface ICreateMessageForAddformResponse400 extends IModelResponse<ICreateMessageForAddformResponseError> {
  statusCode: 400;
}

export interface ICreateMessageForAddformResponse {
  /** Время до следующей отправки кода подтверждения **/
  confirmTimeout?: number | null;
  /** ID заявки **/
  id: number;
  /** Статус ответа **/
  status: EStatus;
}

export interface ICreateMessageForAddformResponseError {
  errors: any[];
  message: string;
}

export type TResponses = ICreateMessageForAddformResponse | ICreateMessageForAddformResponseError;

export enum EStatus {
  /** Не правильный код подтверждения **/
  CodeError = 'codeError',
  /** Дубликат **/
  Duplicate = 'duplicate',
  /** Необходимо подтверждение номера телефона **/
  NeedPhoneConfirm = 'needPhoneConfirm',
  /** Успешно **/
  Ok = 'ok',
}

export enum ECategory {
  /** Аренда койко-места **/
  BedRent = 'bedRent',
  /** Аренда здания **/
  BuildingRent = 'buildingRent',
  /** Продажа здания **/
  BuildingSale = 'buildingSale',
  /** Аренда готового бизнеса **/
  BusinessRent = 'businessRent',
  /** Продажа готового бизнеса **/
  BusinessSale = 'businessSale',
  /** Аренда автосервис **/
  CarServiceRent = 'carServiceRent',
  /** Продажа автосервиса **/
  CarServiceSale = 'carServiceSale',
  /** Аренда коммерческой земли **/
  CommercialLandRent = 'commercialLandRent',
  /** Продажа коммерческой земли **/
  CommercialLandSale = 'commercialLandSale',
  /** Аренда коттеджа **/
  CottageRent = 'cottageRent',
  /** Продажа коттеджа **/
  CottageSale = 'cottageSale',
  /** Посуточная аренда койко-места **/
  DailyBedRent = 'dailyBedRent',
  /** Посуточная аренда квартиры **/
  DailyFlatRent = 'dailyFlatRent',
  /** Посуточная аренда дома, дачи, коттеджа **/
  DailyHouseRent = 'dailyHouseRent',
  /** Посуточная аренда комнаты **/
  DailyRoomRent = 'dailyRoomRent',
  /** Аренда помещения под бытовые услуги **/
  DomesticServicesRent = 'domesticServicesRent',
  /** Продажа помещения под бытовые услуги **/
  DomesticServicesSale = 'domesticServicesSale',
  /** Аренда квартиры **/
  FlatRent = 'flatRent',
  /** Продажа квартиры **/
  FlatSale = 'flatSale',
  /** Продажа доли в квартире **/
  FlatShareSale = 'flatShareSale',
  /** Аренда помещения свободного назначения **/
  FreeAppointmentObjectRent = 'freeAppointmentObjectRent',
  /** Продажа помещения свободного назначения **/
  FreeAppointmentObjectSale = 'freeAppointmentObjectSale',
  /** Аренда гаража **/
  GarageRent = 'garageRent',
  /** Продажа гаража **/
  GarageSale = 'garageSale',
  /** Аренда дома/дачи **/
  HouseRent = 'houseRent',
  /** Продажа дома/дачи **/
  HouseSale = 'houseSale',
  /** Аренда части дома **/
  HouseShareRent = 'houseShareRent',
  /** Продажа части дома **/
  HouseShareSale = 'houseShareSale',
  /** Аренда производства **/
  IndustryRent = 'industryRent',
  /** Продажа производство **/
  IndustrySale = 'industrySale',
  /** Продажа участка **/
  LandSale = 'landSale',
  /** Продажа квартиры в новостройке **/
  NewBuildingFlatSale = 'newBuildingFlatSale',
  /** Аренда офиса **/
  OfficeRent = 'officeRent',
  /** Продажа офиса **/
  OfficeSale = 'officeSale',
  /** Аренда общепита **/
  PublicCateringRent = 'publicCateringRent',
  /** Продажа общепита **/
  PublicCateringSale = 'publicCateringSale',
  /** Аренда комнаты **/
  RoomRent = 'roomRent',
  /** Продажа комнаты **/
  RoomSale = 'roomSale',
  /** Аренда торговой площади **/
  ShoppingAreaRent = 'shoppingAreaRent',
  /** Продажа торговой площади **/
  ShoppingAreaSale = 'shoppingAreaSale',
  /** Аренда таунхауса **/
  TownhouseRent = 'townhouseRent',
  /** Продажа таунхауса **/
  TownhouseSale = 'townhouseSale',
  /** Аренда склада **/
  WarehouseRent = 'warehouseRent',
  /** Продажа склада **/
  WarehouseSale = 'warehouseSale',
}

export enum ECurrency {
  /** € **/
  Eur = 'eur',
  /** ₽ **/
  Rur = 'rur',
  /** $ **/
  Usd = 'usd',
}

export enum EDealType {
  /** Аренда **/
  Rent = 'rent',
  /** Продажа **/
  Sale = 'sale',
}

export enum ERoomCount {
  /** Койко-место **/
  Bed = 'bed',
  /** Пятикомнатная квартира **/
  FiveRoom = 'fiveRoom',
  /** Четырехкомнатная квартира **/
  FourRoom = 'fourRoom',
  /** Многокомнатная квартира (6 и более комнат) **/
  Large = 'large',
  /** Однокомнатная квартира **/
  OneRoom = 'oneRoom',
  /** Квартира со свободной планировкой **/
  OpenPlan = 'openPlan',
  /** Комната **/
  Room = 'room',
  /** Доля в квартире **/
  Share = 'share',
  /** Студия **/
  Studio = 'studio',
  /** Трехкомнатная квартира **/
  ThreeRoom = 'threeRoom',
  /** Двухкомнатная квартира **/
  TwoRoom = 'twoRoom',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: ICreateMessageForAddformResponse): TResponse200;
  400(response: ICreateMessageForAddformResponseError): TResponse400;
}
